import { EsignAcknowledgeModal } from "@/pages/esign/widgets/EsignAcknowledgeModal.tsx";
import { EsignOtpModal } from "@/pages/esign/widgets/EsignOtpModal.tsx";
import { EsignSigningModal } from "@/pages/esign/widgets/EsignSigningModal.tsx";
import { ApiEsignRequest, EsignSignatureType } from "@/types/esign.types.ts";
import { useModals } from "@skailer-com/uikit";
import { useCallback } from "react";

export function useOpenEsignRequest() {
  const { openModal } = useModals();

  return useCallback(
    (request: ApiEsignRequest) => {
      const isAcknowledge = request.signature_type === EsignSignatureType.acknowledge;
      const openTarget = () =>
        openModal(isAcknowledge ? EsignAcknowledgeModal : EsignSigningModal, {
          requestId: request.public_id,
        });

      if (request.identity_verification_required) {
        openModal(EsignOtpModal, { requestId: request.public_id, onVerified: openTarget });
      } else {
        openTarget();
      }
    },
    [openModal]
  );
}
